module.exports = __webpack_public_path__ + "img/payments-subscriptions.eb69a756.svg";